var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "c-infobutton",
          attrs: { title: _vm.title },
          on: {
            click: _vm.toggleModal,
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.toggleModal.apply(null, arguments)
            }
          }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "modal",
            { staticClass: "c-modal--narrow", on: { close: _vm.toggleModal } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.modal.title))]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.modal.description) }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }